import { SALARY_FREQUENCY_OPTIONS, SALARY_TYPE_OPTIONS } from '@workspace/ui/lib';

export const SALARY_TYPE_LITERALS = [SALARY_TYPE_OPTIONS.GROSS, SALARY_TYPE_OPTIONS.NET] as const;
export type SalaryType = (typeof SALARY_TYPE_LITERALS)[number];

export const SALARY_FREQUENCY_LITERALS = [
  SALARY_FREQUENCY_OPTIONS.MONTHLY,
  SALARY_FREQUENCY_OPTIONS.ANNUAL,
] as const;
export type SalaryFrequency = (typeof SALARY_FREQUENCY_LITERALS)[number];
